// @generated - Do not edit: this file is autogenerated by:
//   //dropbox/pap/codegen
//
// Event definition: https://pap.pp.dropbox.com/#/events/2616
import type { PAPEventGeneric } from "../base/event";
import type { Environment } from "../enums/environment";
import type { OperatingSystem } from "../enums/operating_system";
import type { DashSurface } from "../enums/dash_surface";
import type { DashSurfaceBuild } from "../enums/dash_surface_build";
import type { ActionSurfaceComponent } from "../enums/action_surface_component";
import type { DashActionSurface } from "../enums/dash_action_surface";

// Event_name: 'shown.dash_query_suggestion_prompt'
// Description: This event fires when the Query Suggestion Prompt is displayed
// Owner: otc
export type Shown_DashQuerySuggestionPrompt = PAPEventGeneric<
  'dash',
  'shown',
  'dash_query_suggestion_prompt',
  {
    // id that groups all queries in a single "session" for logging
    searchSessionId?: string;
    // the start time of the event in ms
    startTimeMs?: number;
    // Version of Dash (formerly CmdE) Tesla client
    teslaVersion?: string;
    // Whether the app dispatching the event is Prod, Test, or Dev (run locally by the developer)
    environment?: Environment;
    // The operating system platform the user is running on.
    operatingSystem?: OperatingSystem;
    // Which Dash surface (web, desktop, or browser extension) the event originated from.
    dashSurface?: DashSurface;
    // generic property representing build version of whatever is logging this event.
    buildVersion?: string;
    // A unique identifier associated with a specific installation of a specific product. This is unique per install but not per user, as a user may have multiple installations of a given product (reinstalls, multiple devices). Per drl/data_classification, this is L2 Data ("Dropbox-assigned device ID").
    installId?: string;
    // The ID of the Dash session that was in progress when the result was shown. This is a randomly generated UUID string.
    dashSessionId?: string;
    // Defines different types of dash surfaces
    dashSurfaceBuild?: DashSurfaceBuild;
    // The component within a surface in which an action was taken on Dash.
    actionSurfaceComponent?: ActionSurfaceComponent;
    // The surface in which an action was taken on Dash.
    // Note: serp and search_result_page are the same thing, but we're only using serp moving forward.
    dashActionSurface?: DashActionSurface;
    // Identifier for Dash predictions
    predictionId?: string;
    // randomly generated uuid v4 for a Dash Answers conversation
    conversationId?: string;
    // unique id generated by the server for an assist request. Used by the ML team to link user actions on an assistant response and get feedback on usefulness of the response
    assistRequestId?: string;
    // Identifier for a search query
    // Identifier is a v4 uuid that is generated on the fly during a search.
    searchQueryUuid?: string;
  }
>;

export function PAP_Shown_DashQuerySuggestionPrompt(properties?: Shown_DashQuerySuggestionPrompt['properties']): Shown_DashQuerySuggestionPrompt {
  return <Shown_DashQuerySuggestionPrompt>{
    class: 'dash',
    action: 'shown',
    object: 'dash_query_suggestion_prompt',
    properties,
  };
}
